export default __webpack_public_path__ + "static/carousell-autos-services-buyers-icon-2f9f592c20324cb79966585ac916a04f.svg";